import {
  GetDocumentTemplatesDocument,
  GetDocumentTemplatesQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type DocumentTemplate = GetDocumentTemplatesQuery['documents']['templates'][number]

export const useGetDocumentTemplates = () => {
  const { loading, data } = useQuery(GetDocumentTemplatesDocument)

  return {
    loading: loading,
    documentTemplates: data?.documents.templates ?? [],
  }
}
